import actions from "@state/actions";
import { IFile } from "@state/storage/types";
import { containerName } from "@storage/azure-storage-blob";

export const sendFile = async (
  name: string,
  content: string,
  dispatch: any,
  nativeFile?: File,
  container?: string,
  token?: string
) => {
  if (nativeFile) {
    return await sendPromiseFile(
      {
        name: name,
        type: nativeFile.type,
        file: nativeFile,
      },
      dispatch,
      token
    );
  } else {
    var matches: any = content.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
    var type: string = matches[1];
    var buffer = Buffer.from(matches[2], "base64");
    var data = new Blob([buffer], { type: type });
    var file = new File([data], name, { type: type });
    return await sendPromiseFile(
      {
        name: name,
        type: type,
        file: file,
        container: container,
      },
      dispatch,
      token
    );
  }
};

const sendPromiseFile = (
  fileInfo: IFile,
  dispatch: any,
  token?: string | undefined
) => {
  return new Promise((resolve, reject) => {
    dispatch(
      actions.storage.uploadFile(fileInfo, token, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      })
    );
  });
};

export const copyFile = (
  srcs: { oldSrc: string; newSrc: string },
  dispatch: any
) => {
  const duplicateFileData = {
    originContainerName: containerName,
    originFileName: srcs.oldSrc,
    destinationFileName: srcs.newSrc,
  };

  return new Promise((resolve, reject) => {
    dispatch(
      actions.storage.duplicateFile(
        duplicateFileData,
        (result: any, error: any) => {
          console.log("result after dispatch storage", result);

          if (error) {
            reject(error);
          } else {
            resolve(result);
          }
        }
      )
    );
  });
};
